// eslint-disable-next-line @typescript-eslint/no-var-requires
export const defaultCompanyPictureUri = require('@/assets/img/unknow-company.jpg');
// eslint-disable-next-line @typescript-eslint/no-var-requires
export const defaultProfilePictureUri = require('@/assets/img/unknow-user.jpg');
